import CollapsibleCard from "./CollapsibleCard";
import FundingRequestInfo from "./FundingRequestInfo";
import CarrierInformation from "./CarrierInformation";
import { useUserFeature } from "hooks/useUserFeature";

export default function MiddleSections() {
  const { isCarrier } = useUserFeature();

  return (
    <div className="flex flex-col gap-3">
      <CollapsibleCard
        id="funding-request-info"
        title="Funding Request Information"
        titleClassName="text-xl font-normal m-2"
        defaultOpen>
        <FundingRequestInfo />
      </CollapsibleCard>
      {!isCarrier && (
        <CollapsibleCard
          id="carrier-information"
          titleClassName="text-xl font-normal m-2"
          title="Carrier Information">
          <CarrierInformation />
        </CollapsibleCard>
      )}
    </div>
  );
}
